<template>
    <div id="transferPage">
        <div style="margin-top: 40px"></div>
        <a-spin tip="Loading...">
            <div class="spin-content">
            </div>
        </a-spin>
    </div>
</template>

<script>
    import {getUserInfo, uploadSession} from "../Home/homeApiMethod";
    import {loginAction, adfsRequest} from "./loginApiMethod";

    export default {
        name: "transferPage",
        data() {
            return {}
        },
        destroyed() {
        },
        created() {
            if (this.$route.query.uuid && this.$route.query.username) {
                this.getUserLoginStatus()
            } else {
                this.$router.replace({
                    path: '/'
                })
            }
        },
        methods: {
            getUserInfo() {
                getUserInfo().then(res => {
                    console.log(res);
                    this.$store.dispatch('setUserInfo', res).then(() => {
                        location.reload();
                    })
                }).catch(() => {
                })
            },
            getUserLoginStatus() {
                const param = {
                    uuid: this.$route.query.uuid,
                    username: this.$route.query.username
                };
                const that = this;

                this.userNameLogin(param);
                // uploadSession(param).then(res => {
                //     const param1 = {
                //         username: res.username,
                //         message: res.message
                //     };
                //     that.userNameLogin(param1);
                // });
            },
            userNameLogin(param) {
                loginAction(param).then(res => {
                    if (res.errorCode === 200) {
                        this.getUserInfo()
                    }
                })
            }
        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

</style>
